import Vue from "vue";

import App from "./App.vue";
import "element-ui/lib/theme-chalk/index.css";
import router from "./router";
import MaterialKit from "./plugins/material-kit";
import store from "./store";

Vue.use(MaterialKit);

import { LangText } from "./services/helper";
Vue.mixin({
  methods: {
    localeLabel(label) {
      return Locale.localeText(label);
    },
    notifyVue(type = "default", text) {
      if (!text) {
        if (type === "success") {
          text = "Changes have been saved!";
        } else if (type === "danger") {
          text = "Action failed!";
        }
      }
      this.$notify({
        timeout: 3500,
        message: text,
        icon: "add_alert",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: type,
      });
    },
    langtext(value) {
      return LangText(value, this.$store.getters.langindex);
    },
  },
});

new Vue({
  el: "#app",
  render: (h) => h(App),
  store,
  router,
});
